import CalculationStatus from '../../enums/calculationStatus';
import Color from '../../enums/color';
import StatementStatus from '../../enums/statementStatus';
import ReceiptStatus from '../../enums/receiptStatus';
export const getCalculationStatusBadgeColor = (calculationStatus) => ({
    [CalculationStatus.Approved]: Color.Black,
    [CalculationStatus.ApprovedDraft]: Color.Black,
    [CalculationStatus.DraftApprover]: Color.Black,
    [CalculationStatus.DraftCreator]: Color.Black,
    [CalculationStatus.DraftVerifier]: Color.Black,
    [CalculationStatus.DraftUniversal]: Color.Black,
    [CalculationStatus.RejectedCreator]: Color.Black,
    [CalculationStatus.RejectedCreatorAndVerifier]: Color.Black,
    [CalculationStatus.Reopened]: Color.Black,
    [CalculationStatus.ToBeApproved]: Color.Black,
    [CalculationStatus.ToBeReopened]: Color.Black,
    [CalculationStatus.ToBeSubmitted]: Color.Black,
    [CalculationStatus.ToBeVerified]: Color.Black,
    [CalculationStatus.New]: Color.Black
}[calculationStatus]);
export const getStatementStatusBadgeColor = (statementStatus) => ({
    [StatementStatus.Draft]: Color.Black,
    [StatementStatus.Submitted]: Color.Black,
    [StatementStatus.NotSubmitted]: Color.Black
}[statementStatus]);
export const getReceiptStatusBadgeColor = (receiptStatus) => ({
    [ReceiptStatus.NotAvailable]: Color.Black,
    [ReceiptStatus.Received]: Color.Black,
    [ReceiptStatus.NotReceived]: Color.Black
}[receiptStatus]);
export const isRectification = (statementIndex) => statementIndex > 0;
